import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'
import styled from 'styled-components'
import { mediaQueriesBreakpoints } from 'styles/mixins'

const Container = styled.div`
	width: 100%;

	@media ${mediaQueriesBreakpoints.md} {
		width: 16.0625rem;
	}

	padding-bottom: 0.75rem;
`

const Image = styled(Skeleton).attrs({ variant: 'rect' })`
	width: 100%;
	padding-bottom: 52.36%; // Aspect ratio of 191 / 100
`

const Title = styled(Skeleton).attrs({ variant: 'text' })`
	height: 1.75rem;
`

const Button = styled(Skeleton).attrs({ variant: 'rect', width: 80, height: 40 })`
	border-radius: var(--borderRadiusBtn);
`

const ActionsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	height: 2em;
	flex-wrap: nowrap;
`

const InfoContainer = styled.div`
	width: 60%;
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`

const Info = styled(Skeleton).attrs({ variant: 'rect' })``

const CouponCardSkeleton: React.FC = () => (
	<Container data-testid="coupon-card-skeleton">
		<Image />
		<Title />
		<ActionsContainer>
			<InfoContainer>
				<Info />
				<Info />
			</InfoContainer>
			<Button />
		</ActionsContainer>
	</Container>
)

export default CouponCardSkeleton
